<template>
  <div class="product">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" v-html="$t('airportProducts.headerTopText')" data-aos="fade-up"></div>
        <p data-aos="fade-up" data-aos-delay="100">{{$t('airportProducts.headerTopSubText')}}</p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p v-html="$t('airportProducts.headerText')" data-aos="fade-up" data-aos-delay="200"></p>
        <div class="btn-hover">
          <router-link to="/products/airport/presentation" class="btn orange" data-aos="fade-up" data-aos-delay="250">
            {{$t('component.watchPresentation')}}<span/></router-link>
        </div>
      </div>
      <a @click="smoothScroll" data-scroll-offset="120" href="#top" class="more-about-us white" data-aos="fade-up"
         data-aos-delay="300"><span>{{$t('component.moreAboutUs')}}</span></a>
    </header>

    <div id="top" class="why-us-solution">
      <div class="top-text">
        <p v-html="$t('airportProducts.whyOurSolutionText')" data-aos="fade-up"></p>
        <h2 data-aos="fade-up">{{$t('airportProducts.whyOurSolution')}}</h2>
      </div>
      <div class="elements">
        <div class="element right clearfix">
          <div class="image" data-aos="flip-left">
            <figure class="hexagon-image resizable"
                    style="background-image: url('/static/img/product/image1-airport.jpg')">
              <div class="hexTop"></div>
              <div class="hexBottom"></div>
            </figure>
            <div class="line" data-aos="zoom-in-right"></div>
          </div>
          <div class="text-box">
            <div class="heading">
              <div class="hexagon" data-aos="flip-right" data-aos-delay="100"><span>1</span></div>
              <span class="text" data-aos="fade-up">{{$t('airportProducts.sectionOneTitle')}}</span></div>
            <ul>
              <li data-aos="fade-up" data-aos-delay="200">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionOneText1')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="250">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionOneText2')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="300">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionOneText3')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="350">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionOneText4')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="400">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionOneText5')}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="element left clearfix">
          <div class="image" data-aos="flip-right">
            <figure class="hexagon-image resizable"
                    style="background-image: url('/static/img/product/image2-airport.jpg')">
              <div class="hexTop"></div>
              <div class="hexBottom"></div>
            </figure>
            <div class="line" data-aos="zoom-in-left"></div>
          </div>
          <div class="text-box">
            <div class="heading">
              <div class="hexagon" data-aos="flip-right" data-aos-delay="100"><span>2</span></div>
              <span class="text" data-aos="fade-up">{{$t('airportProducts.sectionTwoTitle')}}</span></div>
            <ul>
              <li data-aos="fade-up" data-aos-delay="200">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionTwoText1')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="250">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionTwoText2')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="300">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionTwoText3')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="350">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionTwoText4')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="400">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionTwoText5')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="450">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionTwoText6')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="500">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionTwoText7')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="550">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionTwoText8')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="600">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionTwoText9')}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="element right clearfix">
          <div class="image" data-aos="flip-left">
            <figure class="hexagon-image resizable"
                    style="background-image: url('/static/img/product/image3-airport.jpg')">
              <div class="hexTop"></div>
              <div class="hexBottom"></div>
            </figure>
            <div class="line" data-aos="zoom-in-right"></div>
          </div>
          <div class="text-box">
            <div class="heading">
              <div class="hexagon" data-aos="flip-right" data-aos-delay="100"><span>3</span></div>
              <span class="text" data-aos="fade-up">{{$t('airportProducts.sectionThreeTitle')}}</span></div>
            <ul>
              <li data-aos="fade-up" data-aos-delay="200">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionThreeText1')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="250">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionThreeText2')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="300">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionThreeText3')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="350">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionThreeText4')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="400">
                <span class="dot"></span><span class="text">{{$t('airportProducts.sectionThreeText5')}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-first orange-bg">


      <div class="image-boxes inline-boxes">
        <div class="container">
          <div class="box" data-aos="fade-up" data-aos-delay="100">
            <img src="/static/img/product/image-box-1.jpg" alt="team1">
          </div>
          <div class="box" data-aos="fade-up" data-aos-delay="150">
            <img src="/static/img/product/image-box-2-airport.jpg" alt="team2">
          </div>
          <div class="box" data-aos="fade-up" data-aos-delay="200">
            <img src="/static/img/product/image-box-5.jpg" alt="team3">
          </div>
          <div class="box" data-aos="fade-up" data-aos-delay="250">
            <img src="/static/img/product/image-box-4-airport.jpg" alt="team4">
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-last">
      <div class="content">
        <h2 data-aos="fade-up">{{$t('airportProducts.whyIShouldUseThis')}}</h2>
        <div class="elements">
          <div class="element">
            <Counter :data="circleValues[0]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="150">
              <p>{{$t('airportProducts.whyIShouldUseThisOneText')}}</p>
            </div>
          </div>
          <div class="element">
            <Counter :data="circleValues[1]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="250">
              <p>{{$t('airportProducts.whyIShouldUseThisTwoText')}}</p>
            </div>
          </div>
          <div class="element">
            <Counter :data="circleValues[2]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="350">
              <p>{{$t('airportProducts.whyIShouldUseThisThreeText')}}</p>
            </div>
          </div>
          <div class="element">
            <Counter :data="circleValues[3]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="450">
              <p>{{$t('airportProducts.whyIShouldUseThisFourText')}}</p>
            </div>
          </div>
        </div>
        <div class="btn-hover">
          <router-link to="/products/airport/presentation" class="btn orange" data-aos="fade-up">
            {{$t('component.watchPresentation')}}<span/></router-link>
        </div>
      </div>
    </div>
    <footer-more-information :modalpage="'airport'"/>
    <footer-main/>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import VideoBox from '../components/VideoBox';
  import Counter from '../components/Counter';

  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'airport-product',
    components: {
      FooterMain,
      FooterMoreInformation,
      VideoBox,
      Counter
    },
    data: function () {
      return {
        circleValues: [
          {
            before: this.$t('airportProducts.whyIShouldUseThisOneTopBefore'),
            val: this.$t('airportProducts.whyIShouldUseThisOneTop'),
            after: this.$t('airportProducts.whyIShouldUseThisOneTopAfter'),
          },
          {
            before: this.$t('airportProducts.whyIShouldUseThisTwoTopBefore'),
            val: this.$t('airportProducts.whyIShouldUseThisTwoTop'),
            after: this.$t('airportProducts.whyIShouldUseThisTwoTopAfter'),
          },
          {
            before: this.$t('airportProducts.whyIShouldUseThisThreeTopBefore'),
            val: this.$t('airportProducts.whyIShouldUseThisThreeTop'),
            after: this.$t('airportProducts.whyIShouldUseThisThreeTopAfter'),
          },
          {
            before: this.$t('airportProducts.whyIShouldUseThisFourTopBefore'),
            val: this.$t('airportProducts.whyIShouldUseThisFourTop'),
            after: this.$t('airportProducts.whyIShouldUseThisFourTopAfter'),
          },
        ]

      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      smoothScroll: () => smoothScroll
    },
    methods: {
    }
  }
</script>

<style scoped="">
  .product .page-header {
    background: url(/static/img/product/header-airport.jpg) no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
  }

  .product .bottom-last:after {
    background: url(/static/img/product/bottom-last-airport.jpg) no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
  }
</style>



// WEBPACK FOOTER //
// AirportProduct.vue?7cd87830